export enum DashboardRoutePathsEnum {
  DASHBOARD = '/dashboard',
}
